export interface Employee {
  id: string;
  name: string;
  emiratesId: string;
  nationality: string;
  position: string;
  establishmentId: string;
  establishmentName: string;
  joiningDate: string;
  status: 'active' | 'inactive' | 'absconding';
  wpsStatus: 'paid' | 'unpaid' | 'delayed';
  lastSalaryDate: string;
  salary: number;
}

export const mockEmployees: Employee[] = [
  {
    id: 'EMP001',
    name: 'Ahmed Mohammed Ali',
    emiratesId: '784123456789012',
    nationality: 'Egyptian',
    position: 'Civil Engineer',
    establishmentId: 'EST001',
    establishmentName: 'Al Falah Construction Company',
    joiningDate: '2019-03-15',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 12000
  },
  {
    id: 'EMP002',
    name: 'Fatima Abdullah',
    emiratesId: '784234567890123',
    nationality: 'Emirati',
    position: 'HR Manager',
    establishmentId: 'EST002',
    establishmentName: 'Emirates Technology Solutions',
    joiningDate: '2020-01-10',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 25000
  },
  {
    id: 'EMP003',
    name: 'Rajesh Kumar',
    emiratesId: '784345678901234',
    nationality: 'Indian',
    position: 'Software Developer',
    establishmentId: 'EST002',
    establishmentName: 'Emirates Technology Solutions',
    joiningDate: '2021-05-20',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 15000
  },
  {
    id: 'EMP004',
    name: 'Maria Santos',
    emiratesId: '784456789012345',
    nationality: 'Filipino',
    position: 'Customer Service Representative',
    establishmentId: 'EST005',
    establishmentName: 'Oasis Retail Group',
    joiningDate: '2022-02-15',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 7000
  },
  {
    id: 'EMP005',
    name: 'Mohammed Al Hashimi',
    emiratesId: '784567890123456',
    nationality: 'Emirati',
    position: 'Operations Manager',
    establishmentId: 'EST006',
    establishmentName: 'Desert Star Logistics',
    joiningDate: '2018-11-05',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 30000
  },
  {
    id: 'EMP006',
    name: 'John Smith',
    emiratesId: '784678901234567',
    nationality: 'British',
    position: 'Marketing Director',
    establishmentId: 'EST010',
    establishmentName: 'Golden Sands Tourism',
    joiningDate: '2019-08-12',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 28000
  },
  {
    id: 'EMP007',
    name: 'Aisha Rahman',
    emiratesId: '784789012345678',
    nationality: 'Pakistani',
    position: 'Accountant',
    establishmentId: 'EST009',
    establishmentName: 'Marina View Real Estate',
    joiningDate: '2020-06-30',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 10000
  },
  {
    id: 'EMP008',
    name: 'Li Wei',
    emiratesId: '784890123456789',
    nationality: 'Chinese',
    position: 'Chef',
    establishmentId: 'EST003',
    establishmentName: 'Al Majid Hospitality Group',
    joiningDate: '2021-02-10',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 9000
  },
  {
    id: 'EMP009',
    name: 'Omar Farooq',
    emiratesId: '784901234567890',
    nationality: 'Pakistani',
    position: 'Machine Operator',
    establishmentId: 'EST004',
    establishmentName: 'Gulf Manufacturing Industries',
    joiningDate: '2022-01-15',
    status: 'absconding',
    wpsStatus: 'unpaid',
    lastSalaryDate: '2023-12-28',
    salary: 5000
  },
  {
    id: 'EMP010',
    name: 'Priya Sharma',
    emiratesId: '784012345678901',
    nationality: 'Indian',
    position: 'Nurse',
    establishmentId: 'EST007',
    establishmentName: 'Sunrise Healthcare Services',
    joiningDate: '2020-09-22',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 12000
  },
  {
    id: 'EMP011',
    name: 'Abdul Rahman',
    emiratesId: '784123456789013',
    nationality: 'Bangladeshi',
    position: 'Construction Worker',
    establishmentId: 'EST001',
    establishmentName: 'Al Falah Construction Company',
    joiningDate: '2021-11-10',
    status: 'absconding',
    wpsStatus: 'unpaid',
    lastSalaryDate: '2024-01-28',
    salary: 4000
  },
  {
    id: 'EMP012',
    name: 'Sarah Johnson',
    emiratesId: '784234567890124',
    nationality: 'American',
    position: 'Teacher',
    establishmentId: 'EST008',
    establishmentName: 'Al Noor Educational Institute',
    joiningDate: '2019-08-25',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 18000
  },
  {
    id: 'EMP013',
    name: 'Ali Hassan',
    emiratesId: '784345678901235',
    nationality: 'Egyptian',
    position: 'Security Guard',
    establishmentId: 'EST005',
    establishmentName: 'Oasis Retail Group',
    joiningDate: '2022-03-01',
    status: 'active',
    wpsStatus: 'delayed',
    lastSalaryDate: '2024-01-28',
    salary: 5500
  },
  {
    id: 'EMP014',
    name: 'Mei Lin',
    emiratesId: '784456789012346',
    nationality: 'Chinese',
    position: 'Graphic Designer',
    establishmentId: 'EST002',
    establishmentName: 'Emirates Technology Solutions',
    joiningDate: '2021-07-15',
    status: 'active',
    wpsStatus: 'paid',
    lastSalaryDate: '2024-02-28',
    salary: 11000
  },
  {
    id: 'EMP015',
    name: 'Tariq Mahmood',
    emiratesId: '784567890123457',
    nationality: 'Pakistani',
    position: 'Driver',
    establishmentId: 'EST006',
    establishmentName: 'Desert Star Logistics',
    joiningDate: '2020-10-05',
    status: 'absconding',
    wpsStatus: 'unpaid',
    lastSalaryDate: '2023-11-28',
    salary: 4500
  }
];

export const searchEmployees = (query: string): Employee[] => {
  const lowerCaseQuery = query.toLowerCase();
  return mockEmployees.filter(
    (employee) =>
      employee.name.toLowerCase().includes(lowerCaseQuery) ||
      employee.emiratesId.includes(query) ||
      employee.establishmentName.toLowerCase().includes(lowerCaseQuery)
  );
};

export const searchAbscondingEmployees = (): Employee[] => {
  return mockEmployees.filter(
    (employee) => employee.status === 'absconding'
  );
};

export const searchWpsIssues = (): Employee[] => {
  return mockEmployees.filter(
    (employee) => employee.wpsStatus === 'unpaid' || employee.wpsStatus === 'delayed'
  );
};